import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGIN_UPDATE,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_USER_BY_TOKEN,
} from "./actionTypes";

const initialState = {
  error: "",
  user: JSON.parse(localStorage.getItem('authUser')) || null,
  profile : JSON.parse(localStorage.getItem('authUser'))?.resultset_2 ? JSON.parse(localStorage.getItem('authUser'))?.resultset_2[0] : null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state
      };
      break;
    case LOGIN_USER_BY_TOKEN:
      state = {
        ...state
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        user: action.payload.user, 
        profile: action.payload.profile, 
      };
      break;
    case LOGIN_UPDATE:
      state = {
        ...state,
        profile: action.payload.profile, 
      };
      break;
    case LOGOUT_USER:
      state = { ...state, isUserLogout: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { 
        ...state, 
        user: null,
        profile: null,
        isUserLogout: true 
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        isUserLogout: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
